import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { NTTProperties, useNTTProperties } from "./NTTProperties";

import { DraftNTTButtonComponent } from "./DraftNTTButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { NTTButton } from "./NTTButton";
import { Registry } from "../../../../base/register";

export const NTTButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useNTTProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <NTTButton {...properties} className={className}>
            {children}
        </NTTButton>
    )
}

Registry.addControl({
    id: "c79126c9-6a81-4225-9e21-7d23eb17ddf3",
    name: "NTT Pay Button",
    type: ControlType.NTTPayButton,
    properties: NTTProperties,
    component: NTTButtonComponent,
    draftComponent: DraftNTTButtonComponent
})
